module.exports = __webpack_public_path__ + "img/circulo_banner_center.39b0d250.png";